/**
 * Convert a Date object to YYYY-MM-DD string in LOCAL timezone.
 * Avoids the toISOString() UTC bug where dates shift after ~7PM EST.
 */
export function toLocalDateStr(d) {
  const date = d instanceof Date ? d : new Date(d);
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
}
